<template>
<div class="ChecklistStatusDialogColorPicker">
  <div v-for="(color, i) in customStatusesColors"
       :key="`color-${i}`"
       class="ChecklistStatusDialogColorPicker__item clickable"
       :class="{'ChecklistStatusDialogColorPicker__item--active': modelValue === color}"
       :style="{backgroundColor: color}"
       @click="$emit('update:modelValue', color)"
  ></div>
</div>
</template>

<script>
import { customStatusesColors } from '@/project/checklist/dialogs/taskStatus'

export default {
  name: 'ChecklistStatusDialogColorPicker',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      customStatusesColors,
    }
  },
}
</script>

<style scoped lang="scss">
.ChecklistStatusDialogColorPicker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  &__item {
    width: 26px;
    height: 26px;
    margin: 8px;
    border-radius: 50%;
    &--active {
      border: 2px solid rgb(var(--v-theme-tertiary));
    }
  }
}
</style>
